/**
 * @file AnchorShowPassword
 */

'use strict';

/**
 * @classname AnchorShowPassword
 * @classdesc パスワード表示
 */
export default class AnchorShowPassword {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.anchor-show-password');
	 */
	constructor($e) {
		console.log(`AnchorShowPassword.constructor`);
		this._$e = $e;
		this._$input = $e.parent('.col-12').find('input');
		this._$e.on('click', () => this.onClick());
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof AnchorShowPassword
	 * @return {undefined}
	 */
	onClick() {
		console.log(`AnchorShowPassword.onClick`);
		if(this._$e.hasClass('show')) {
			this._$e.removeClass('show');
			this._$input.attr('type', 'password');
		} else {
			this._$e.addClass('show');
			this._$input.attr('type', 'text');
		}
	};
}
